module.exports = __webpack_public_path__ + "static/lframe-debtcon-v3-b66409874fd7a806842ff9b8eb282085.png";